<template>
	<div>
        <div class="lds-dual-ring dark" v-if="loading"></div>
        <div class="voucher" v-else>
            <h2>Your voucher code</h2>
            <div v-if="config.qr_code">
              <img :src="config.qr_code" alt="voucher code" />
            </div>
            <div v-if="config.show_code != false" :class="{redeemed:redeemed}" >
                <span  class=code :style="getStyle('code')" :class="{strike:redeemed}">{{config.uniquecode.replace(/(\d{4})/g, '$1 ').replace(/(^\s+|\s+$)/,'')}}</span>
            </div>
            <p v-if="config.show_toggle_gift_card_value != false">Your current balance is <strong v-html="'&pound;'+(config.balance/100)"></strong></p>

            <p v-if="config.expiry_time && config.validity_start_time && config.expiry_time == config.validity_start_time"><small>Valid on {{displayDate(config.expiry_time)}}</small></p>
            <p v-else-if="config.expiry_time && config.validity_start_time"><small>Valid from {{displayDate(config.validity_start_time)}} to {{displayDate(config.expiry_time)}}</small></p>
            <p v-else-if="config.validity_start_time"><small>Valid from {{displayDate(config.validity_start_time)}}</small></p>
            <p v-else-if="config.expiry_time"><small>Valid until {{displayDate(config.expiry_time)}}</small></p>

            <ul class="instructions" v-if="config.voucher_instructions">
              <li v-for="(instruction,index) in config.voucher_instructions" :key="index">
                <span class="numberCircle">{{index}}</span>
                <p>{{instruction}}</p>
              </li>
            </ul>

            <p><small v-html="config.cta_upper_text"></small></p>
            <p><a :href="config.cta_link" target="_blank" class="button" :style="getStyle('button')">{{config.cta_text}}</a></p>
            <p v-if="config.display_pin"><small>Your PIN is <strong>{{config.pin}}</strong></small></p>
        </div>
	</div>
</template>

<script>
export default {
  name: 'ToggleVoucher',
  props: {
    email: String
  },
  data : function(){       
    return {
      code :false,
      redeemed_at:false,
      redeemed:false
    }
  },
  computed: {
      config(){
          return this.$store.getters.getCamapignConfig;
      },

      loading(){
          return this.$store.getters.getAppLoading;
      },

      apiCampaignParams(){
          return this.$store.getters.getCampaignApiVars;
      },

      unit(){
          return this.$store.getters.getUnit;
      },
  },
  created : function(){
    this.$store.commit("SET_APP_LOADING",true);
    this.displayVoucher();
  },
  mounted : function(){
  },
  methods: {
    displayVoucher()
    {
      this.$store.commit("SET_APP_LOADING",false);
    },
    displayDate(date)
    {
      let displayDate = new Date(date);
      let day = displayDate.getDate();
      let month = displayDate.getMonth()+1;
      let year = displayDate.getFullYear();
      return day+'/'+month+'/'+year;
    }
  }
}
</script>

<style lang="scss">

    @keyframes strike{
      0%   { width : 0; }
      100% { width: 80%; }
    }
    .strike {
      position: relative;
    }
    .strike::after {
      margin-left:10%;
      content: ' ';
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      height: 3px;
      margin-top:-3px;
      background: black;
      animation-name: strike;
      animation-duration: 0.5s;
      animation-timing-function: linear;
      animation-iteration-count: 1;
      animation-fill-mode: forwards; 
    }
    .code {
        font-size: 24px !important;
    }

    ul {
      list-style: none;
      display: inline-block;
      li {
        margin-top: 30px;

        p {
          font-size: 15px;
        }
      }
      .numberCircle {
        padding: 10px 14px;
      }
    }

</style>